// extracted by mini-css-extract-plugin
export var addressFields = "_p6-0";
export var animationContainer = "_p6-1";
export var footer = "_p6-2";
export var lineItems = "_p6-3";
export var modalContent = "_p6-4";
export var orderName = "_p6-5";
export var strong = "_p6-6";
export var warning = "_p6-7";